import { GetRepeatableSpaceBase } from '../../types/GetRepeatableSpaceBase';
import { getUndefinedRepeatableSpace } from '../../utils/getUndefinedRepeatableSpace';
import { repeatableSpaceFactory } from '../../utils/repeatableSpaceFactory';

export const getRepeatableSpaceGeneral: GetRepeatableSpaceBase = (
  group,
  space,
  _context,
) => {
  switch (group) {
    case 'ID_VALIDATION_WELCOME': {
      switch (space) {
        case 'rows': {
          const sp = repeatableSpaceFactory(
            'ID_VALIDATION_WELCOME__rows',
            [ 'icon', 'label', 'description' ],
          );
          sp.addRows([ 'secure', 'encrypted' ]);
          return sp.get();
        }
        default: break;
      }
      break;
    }
    default: break;
  }

  return getUndefinedRepeatableSpace(true); // if not found here, error
};
